import { useRouter } from 'next/router';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';

import { useAppDispatch, useAppSelector } from '@/store/hooks';

import { OFFICE_URL } from '@/shared/constants/paths';
import { useTranslate } from '@/shared/hooks/use-translate';
import { Heading } from '@/shared/ui/heading';
import { DangerIcon, SuccessIcon } from '@/shared/ui/icons';

// TODO: убрать Styled в названии в задаче ARKZ-515
import {
    StyledProductTitleContainer,
    StyledProductTitleRow,
    StyledStatusParagraph,
    StyledAddressParagraph,
} from './styled';

export type TProps = {
    name: string;
    city: string;
    location: string;
    coords: TCoordinates;
    setCoordinates: (value: TCoordinates) => void;
};

export const ProductTitle: FC<TProps> = ({ name, city, location, coords, setCoordinates }) => {
    const theme = useTheme();
    const { t } = useTranslate();
    const dispatch = useAppDispatch();
    const { push } = useRouter();
    const { cityUser } = useAppSelector((state) => state.user);

    const handleOpenOffice = () => {
        dispatch(setCoordinates(coords));
        push(OFFICE_URL);
    };

    return (
        <StyledProductTitleContainer>
            <Heading as="h1" sizeMobile="lg" marginB="12" marginBMobile="12">
                {name}
            </Heading>
            <StyledProductTitleRow>
                {city === cityUser?.name ? (
                    <>
                        <SuccessIcon width={16} color={theme.color.primary} />
                        <StyledStatusParagraph>{t('Товар находится в вашем городе')}</StyledStatusParagraph>
                    </>
                ) : (
                    <>
                        <DangerIcon width={16} />
                        <StyledStatusParagraph>
                            {t('Товар находится в г.')} {city}
                        </StyledStatusParagraph>
                    </>
                )}
            </StyledProductTitleRow>
            <StyledAddressParagraph onClick={handleOpenOffice} style={{ cursor: 'pointer' }}>
                {location}
            </StyledAddressParagraph>
        </StyledProductTitleContainer>
    );
};
